module.exports = __webpack_public_path__ + "static/media/success.e80814ed.svg";